import { Fragment } from "react";

import BriefingsSection from "content-ui/briefings/components/briefingsSection/briefingsSection";
import type { BriefingsPageProps } from "pages/pro/briefings";
import PromoTextWithAction from "components/promoTextWithAction/promoTextWithAction";
import CommonHero from "components/commonHero/commonHero";

import FeaturedBriefing from "./components/featuredBriefing/featuredBriefing";
import { useMixpanelTracking } from "../../lib/hooks/useMixpanelTracking";

type BriefingsViewProps = BriefingsPageProps;

const BriefingsView = ({ briefings, params, pageData }: BriefingsViewProps) => {
  const { title, subHeading } = pageData;
  const { track } = useMixpanelTracking();

  return (
    <Fragment>
      <main className={"bg-white pt-[60px] lg:pt-[69px]"}>
        <div>
          <CommonHero
            title={title}
            subtitle={subHeading}
            brandColor={"pro-blue"}
          />
        </div>
        <div className="max-w-[1140px] px-5 md:mx-auto lg:max-w-[1220px] lg:px-0 ">
          <div
            className={
              "mx-[-20px] mt-[50px] flex h-full flex-col gap-x-5 md:mx-0 lg:flex-row"
            }
          >
            <FeaturedBriefing pageData={pageData} briefings={briefings} />
            {pageData.promoCardText &&
              pageData.promoCardCtaText &&
              pageData.promoCardCtaUrl && (
                <div className={"w-full min-w-[290px] lg:w-[290px]"}>
                  <PromoTextWithAction
                    text={pageData.promoCardText}
                    actionText={pageData.promoCardCtaText}
                    href={pageData.promoCardCtaUrl}
                    wrapperClasses={
                      "w-full h-full px-[30px] min-h-[180px] lg:min-h-full [&_div]:max-w-[290px]"
                    }
                    titleClasses={"line-clamp-4"}
                    onClick={async () =>
                      track("Briefings list promo CTA click", {
                        "Link click": pageData.promoCardCtaUrl,
                        "Link text": pageData.promoCardCtaText,
                      })
                    }
                  />
                </div>
              )}
          </div>
          <BriefingsSection
            pageData={pageData}
            briefings={briefings}
            params={params}
          />
        </div>
      </main>
    </Fragment>
  );
};

export default BriefingsView;
